/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
export default (video) => video?.type.toLowerCase() === 'youtube' || /vimeo/i.test(video?.video_id);
